import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';

export default function RootLayout(): React.JSX.Element {
   return (
      <>
         <Header />
         <div className="md-container">
            <main className="md-main">
               <div className="md-main__inner md-grid">
                  <div className="md-content">
                     <Outlet />
                  </div>
               </div>
            </main>
         </div>
      </>
   );
}
